import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { JiraTaskComponent } from './jira-task/jira-task.component';
import {FormsModule} from "@angular/forms";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {HttpClientModule} from "@angular/common/http";
import {BlockUIModule} from "ng-block-ui";
import {ToasterModule, ToasterService} from "angular2-toaster";
import { FileinputDirective } from './fileinput.directive';

@NgModule({
  declarations: [
    AppComponent,
    JiraTaskComponent,
    FileinputDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    BlockUIModule.forRoot(),
    ToasterModule,
  ],
  providers: [ToasterService],
  bootstrap: [AppComponent]
})
export class AppModule { }
